import React, { useState } from 'react'
import classes from './Footer.module.css'
import { SocialIcon } from 'react-social-icons';
import '../Navigation/Navigation.css'
import { Element } from 'react-scroll';

const Footer = () => {

    const [secondText, setsecondText] = useState(false)
    const [firstText, setfirstText] = useState(true)
    const handleMouseEnter = () => {
        setsecondText(true)
        setfirstText(false)
    }

    const handleMouseLeave = () => {
        setsecondText(false)
        setfirstText(true)
    }
    return (
        <><Element name='Contact'></Element>
            <footer>

                <div className={classes.credit}>
                    <p>The wordsmith behind the blog posts was none other than ChatGPT, the quick-witted AI language model trained by OpenAI.</p>
                </div>
                <div className={classes.animationBox}>
                    <div className='firstBox'>
                        <div className='firstTextBox'>
                            {firstText && <h3 className={` ${firstText ? 'slide-up' : 'slide-down'}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>SIMPLICITY</h3>}
                            {secondText && <h3 className={` ${secondText ? 'slide-up-grand' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>SPACE</h3>}
                        </div>
                    </div>
                </div>
                <div className={classes.socials}>
                    <SocialIcon className={classes.socialsIcon} url='https://www.linkedin.com/in/simplicity-space-6187b4267' network="linkedin" />
                    <SocialIcon className={classes.socialsIcon} url='https://twitter.com/SimplicitySpace' network="twitter" />
                    <SocialIcon className={classes.socialsIcon} url='https://instagram.com/simplicity_spaces?igshid=YmMyMTA2M2Y=' network="instagram" />
                </div>
            </footer></>
    )
}

export default Footer